import { intersectionWatcher, delayOffset } from "@/lib/animation";

const selectors = {
  productItems: ".animation--item",
  introductionItems: ".animation--section-introduction > *",
};

export default node => {
  delayOffset(node, [selectors.introductionItems, selectors.productItems]);
  const observer = intersectionWatcher(node);

  return {
    destroy() {
      observer?.destroy();
    },
  };
};
